import { SessionClosed } from './SessionClosed'

export * from "./hooks/useSessionClosed"

export default SessionClosed;